module.exports = __webpack_public_path__ + "img/code.2e6986fe.png";